import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';

interface RefreshIconCellRendererParams extends ICellRendererParams {
	iconName?: string;
	onIconClick?: (params?: ICellRendererParams) => void;
}
@Component({
	selector: 'copo-click-icon-cell',
	templateUrl: './click-icon-cell.component.html',
	styleUrl: './click-icon-cell.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [MatIconModule, MatRippleModule]

})
export class ClickIconCellComponent implements ICellRendererAngularComp {
	@Input() iconName!: string;
	@Input() iconClickHandler!: (params?: ICellRendererParams) => void;
	private params!: ICellRendererParams;

	agInit(params: RefreshIconCellRendererParams): void {
		this.iconName = params.iconName ?? '';
		this.params = params;
		this.iconClickHandler = params.onIconClick ?? (() => { /* no-op */ });
	}

	refresh(params: RefreshIconCellRendererParams): boolean {
		this.iconClickHandler = params.onIconClick ?? (() => { /* no-op */ });
		this.params = params;
		return true;
	}

	onIconClick(): void {
		this.iconClickHandler(this.params);
	}
}
